export const CREATE_TITLE = 'Adicionar feriado';
export const EDIT_TITLE = 'Editar feriado';

export const FIELD_LABELS = {
    date: 'Data',
    name: 'Nome do feriado',
    scope: 'Alcance',
    recurring: 'Repete na mesma data todo ano',
} as const;

export const NAME_PLACEHOLDER = 'Ex.: Confraternização Universal';

export const RECURRING_HELP =
    'Desmarque para feriados móveis (Carnaval, Sexta-feira Santa, Corpus Christi): eles mudam de data e não são copiados para o próximo ano.';

export const SUBMIT_CREATE = 'Adicionar';
export const SUBMIT_EDIT = 'Salvar';
export const SUBMITTING_LABEL = 'Salvando...';
export const CANCEL_LABEL = 'Cancelar';
